import hero from '../../Images/hero11.png'
import hero2 from '../../Images/hero2.png'
import hero3 from '../../Images/hero3.png'
import hero4 from '../../Images/hero4.png'

export const BannerImgList  = [
    {
        hero: hero
    },
    {
        hero: hero2
    },
    {
        hero: hero3
    },
    {
        hero: hero4
    },
]